/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { isOLBApp } from '../../utils/browserutils'
import {
  addLocationOrigin,
  handleBatchedRequests
} from '../../utils/microAppUtils'

const Loader = React.lazy(() => import('@usb-diy/loader'))

const OlbWrapper = ({ children }) => {
  const [areMicroAppsLoading, setAreMicroAppsLoading] = useState(true)
  const [microAppUrls, setMicroAppUrls] = useState({ header: '', footer: '' })
  const { ReturnURL, LogoutURL } =
    (typeof sessionStorage !== 'undefined' && sessionStorage) || {}

  const getMicroAppLocations = async () => {
    const urls = {
      footer: addLocationOrigin(
        '/digital/servicing/global-footer/manifest.json'
      ),
      header: addLocationOrigin('/digital/servicing/global-nav/manifest.json')
    }

    const sourceUrls = await handleBatchedRequests(urls)

    setMicroAppUrls(sourceUrls)
    setAreMicroAppsLoading(false)
  }

  useEffect(() => {
    if (isOLBApp()) {
      getMicroAppLocations()
    }
  }, [isOLBApp])

  return (
    <div className="olb-wrapper">
      {!areMicroAppsLoading && isOLBApp() && (
        <Loader
          selector="#usb-header-component"
          src={microAppUrls?.header}
          namespace="USBHeader"
          renderWhileLoading={() => 'Loading Global Navigation Menu'}
          uri="/" // put the uri for the real graphql endpoint that will be needed by the global-nav app
          props={{
            ReturnURL,
            LogoutURL
          }}
        />
      )}
      {children}
      <div className="main-footer">
        {isOLBApp() && !areMicroAppsLoading && (
          <Loader
            selector="#usb-footer-component"
            src={microAppUrls?.footer}
            namespace="USBFooter"
            renderWhileLoading={() => 'Loading Global Footer'}
            uri="/"
          />
        )}
      </div>
    </div>
  )
}

OlbWrapper.propTypes = {
  children: PropTypes.PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.array,
    PropTypes.object,
    PropTypes.node
  ]).isRequired
}

export default OlbWrapper
